import { Livewire } from '@shared/livewire.js'
import '@/Signups/Components/signup/map.js'

Livewire.start()
